import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(private readonly _snackBar: MatSnackBar) {
  }

  private static isSilentError (error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse &&
      (error.status === 401 || error.status === 422 || error.status === 400 || error.status === 307)) {
      return true;
    }
    if (error instanceof  HttpErrorResponse &&
      error.url?.includes('qt_QtService/saveVariantAnswers')) {
      return true;
    }
    if (error instanceof  Error && error.message === 'No refresh token') {
      return true;
    }
    return false;
  }

  handleError(error: Error | HttpErrorResponse | any): void {
    if (!AppErrorHandler.isSilentError(error)) {
      console.error(error?.error?.message || error?.message);
      this._snackBar.open(error?.error?.message || error.message, 'Ок', {
        direction: 'ltr',
        panelClass: 'error-snack-bar',
        horizontalPosition: 'center',
        politeness: 'assertive',
        verticalPosition: 'bottom',
        duration: 10000
      });
    }
  }
}

